var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedFilegov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#EAECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 11.333H13.9998C13.6462 11.333 13.3071 11.4735 13.057 11.7235C12.807 11.9736 12.6665 12.3127 12.6665 12.6663V23.333C12.6665 23.6866 12.807 24.0258 13.057 24.2758C13.3071 24.5259 13.6462 24.6663 13.9998 24.6663H21.9998C22.3535 24.6663 22.6926 24.5259 22.9426 24.2758C23.1927 24.0258 23.3332 23.6866 23.3332 23.333V15.9997M18.6665 11.333L23.3332 15.9997M18.6665 11.333V15.9997H23.3332",
    stroke: "#1782D5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05887 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05887 27.9411 0 18 0V4ZM18 0C8.05887 0 0 8.05887 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "#F5F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFilegov);
export default __webpack_public_path__ + "static/media/uploaded-file.gov.17c5c8e05687de78ce9d96705602ef4d.svg";
export { ForwardRef as ReactComponent };